import React from 'react';
import { useAdaptiveSize, useNodeTree } from "../hooks";
import { NodesProvider } from "./NodesProvider";
export var AdaptiveNodesProvider = function AdaptiveNodesProvider(_ref) {
  var coreDSL = _ref.coreDSL,
    components = _ref.components,
    children = _ref.children;
  var nodeTree = useNodeTree(coreDSL, components);
  var size = useAdaptiveSize(nodeTree.extractUniqueParamValues('size'));
  return /*#__PURE__*/React.createElement(NodesProvider, {
    nodeTree: nodeTree,
    size: size
  }, children);
};